import { matchPath, useLocation } from "react-router-dom";
import useResponsive from "src/utils/useResponsive";
import PreownedHeader from "./PreownedHeader/PreownedHeader";
import { Button } from "@zarafront/lib-zds";
import ZaraHeader from "./ZaraHeader/ZaraHeader";
import { ROUTE_PATHS } from "src/utils/constants";
import { t } from "i18next";
import { useEffect } from "react";
import { PURCHASE_ORDER_QUERY_PARAM_CODE, SALE_ORDER_QUERY_PARAM_CODE } from "src/constants/UrlConstants";
import { useTextZoom } from "src/hooks/Utils/useTextZoom";

const zaraHeadersRoutes = [
  ROUTE_PATHS.CART,
  ROUTE_PATHS.PAYMENT_CONFIRMATION,
  ROUTE_PATHS.CHECKOUT,
];

const notHeaderRouteMatchers = [
  {
    path: `${ROUTE_PATHS.PRODUCT_DETAIL}/:id`,
    exact: true,
    allowSearch: false,
  },
];

const MainHeader = () => {
  useTextZoom();
  const { WS, WSM } = useResponsive();
  const { pathname, search } = useLocation();
  const queryParams = new URLSearchParams(search);

  const isPublicPdp =
    !!matchPath(pathname, {
      path: `${ROUTE_PATHS.PRODUCT_DETAIL}/:id`,
      exact: true,
    }) &&
    !queryParams.has(SALE_ORDER_QUERY_PARAM_CODE) &&
    !queryParams.has(PURCHASE_ORDER_QUERY_PARAM_CODE);

  const notShowHeader = isPublicPdp && WSM;

  const isCartDesktop = pathname.includes(ROUTE_PATHS.CART) && WS;

  const showZaraHeader =
    zaraHeadersRoutes.some((route) => pathname.includes(route)) && WSM;

  const scrollToMainContent = () => {
    const el = document.getElementById("main-content");
    if (el) {
      el.setAttribute("tabindex", "-1");
      setTimeout(() => {
        el.focus({ preventScroll: true });
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 50);
    }
  };

  useEffect(() => {
    const removeTabIndex = () => {
      const el = document.getElementById("main-content");
      if (el && el.getAttribute("tabindex") === "-1") {
        el.removeAttribute("tabindex");
      }
    };

    document.addEventListener("click", removeTabIndex, true);
    return () => document.removeEventListener("click", removeTabIndex, true);
  }, []);

  return (
    <>
      {!notShowHeader && (
        <>
          <Button
            variant="primary"
            className="skip-link"
            id="skip-link"
            onClick={scrollToMainContent}
          >
            {t("skip_to_main_content") || "Skip to main content"}
          </Button>
          {!isCartDesktop && (
            <>
              {!showZaraHeader &&
              (WS || pathname.includes(ROUTE_PATHS.PRODUCTS)) ? (
                <PreownedHeader />
              ) : showZaraHeader && WSM ? (
                <ZaraHeader />
              ) : null}
            </>
          )}
        </>
      )}
    </>
  );
};

export default MainHeader;
